import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CabinetClientPageComponent } from '../../layout/cabinet-client-page.component';
import { CLIENT_CABINET_PAGE_ICONS } from '../../layout/cabinet-client-page-icons.util';
import { CabinetTariffsViewComponent } from '../../tariffs/cabinet-tariffs-view.component';

@Component({
  selector: 'app-dashboard-client-tariffs-page',
  imports: [CabinetClientPageComponent, CabinetTariffsViewComponent],
  template: `
    <lib-cabinet-client-page
      titleKey="CLIENT.CABINET.NAV.TARIFFS"
      [iconSrc]="pageIcon"
    >
      <lib-cabinet-tariffs-view />
    </lib-cabinet-client-page>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardClientTariffsPage {
  protected readonly pageIcon = CLIENT_CABINET_PAGE_ICONS.tariffs;
}
